// extracted by mini-css-extract-plugin
export var childrenContainer = "_ct-0";
export var virtualScrollArea = "_ct-1";